<template>
  <button
    class="ios-switch"
    :class="{
      'ios-switch--on': isOn,
      'ios-switch--disabled': disabled,
    }"
    :style="{
      '--active-color': activeColor,
    }"
    type="button"
    :disabled="disabled"
    @click="toggle"
  >
    <span class="ios-switch__thumb" />
  </button>
</template>

<script>
export default {
  name: "AppSwitch",

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    activeColor: {
      type: String,
      default: "#34C759",
    },
  },

  computed: {
    isOn() {
      return this.value;
    },
  },

  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit("input", !this.value);
    },
  },
};
</script>

<style scoped lang="less">
.ios-switch {
  position: relative;
  width: 52px;
  height: 28px;
  border-radius: 16px;
  background-color: #e5e5ea;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.25s ease;
}

.ios-switch--on {
  background-color: var(--active-color, #34c759);
}

.ios-switch__thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  transition: transform 0.25s ease;
}

.ios-switch--on .ios-switch__thumb {
  transform: translateX(24px);
}

.ios-switch--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
